import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { renderNothing } from 'recompose';
import ScheduleItems from './schedule-items';
import enhance from './enhance';
import { fadeInTime } from './schedule.css';

class Schedule extends Component {
  componentDidMount() {
    this.props.fetch();
  }

  render() {
    return (
      <div className="schedule">
        <ReactCSSTransitionGroup
          transitionName="fade-in"
          transitionEnterTimeout={parseInt(fadeInTime)}
          transitionLeaveTimeout={parseInt(fadeInTime)}
        >
          <ScheduleItems eventIds={this.props.eventIds} key="schedule-items" />
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

export default enhance(Schedule);



// WEBPACK FOOTER //
// ./src/components/schedule/index.js